import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import { defineComponent } from '@vue/composition-api';

var script = defineComponent({
    name: 'MaintenanceChecker',
    props: {
        checkedParts: {
            type: Array,
            required: true,
        },
        isInMaintenance: {
            type: Function,
            required: true,
        }
    },
    watch: {
        arePartsInMaintenance: function (value) {
            if (value) {
                this.closeOpenedEvents();
                this.scrollToTop();
            }
        },
    },
    computed: {
        arePartsInMaintenance: function () {
            var _this = this;
            return this.checkedParts.some(function (part) { return _this.isInMaintenance(part); });
        },
    },
    methods: {
        closeOpenedEvents: function () {
            var _a = useVueRouter(), pushRoute = _a.pushRoute, route = _a.route;
            pushRoute({ path: route.value.path });
        },
        scrollToTop: function () {
            window.scrollTo(0, 0);
        },
    },
});

export default script;
